import { useContext, createContext } from 'react'

const MainContext = createContext(null)
const useMainContext = () => useContext(MainContext)

const TorContext = createContext(null)
const useTorContext = () => useContext(TorContext)

const LeagueContext = createContext(null)
const useLeagueContext = () => useContext(LeagueContext)

const PrivateContext = createContext(null)
const usePrivateContext = () => useContext(PrivateContext)

const PrivateClubContext = createContext(null)
const usePrivateClubContext = () => useContext(PrivateClubContext)

const PrivateClubFedContext = createContext(null)
const usePrivateClubFedContext = () => useContext(PrivateClubFedContext)

const PrivateClubTeamContext = createContext(null)
const usePrivateClubTeamContext = () => useContext(PrivateClubTeamContext)

const CaptainContext = createContext(null)
const useCaptainContext = () => useContext(CaptainContext)

export {
  MainContext,
  useMainContext,
  TorContext,
  useTorContext,
  LeagueContext,
  useLeagueContext,
  PrivateContext,
  usePrivateContext,
  PrivateClubContext,
  usePrivateClubContext,
  CaptainContext,
  useCaptainContext,
  PrivateClubFedContext,
  usePrivateClubFedContext,
  PrivateClubTeamContext,
  usePrivateClubTeamContext
}
